import { Modal } from "flowbite";
import { CreateNote } from "./CreateNote";
import { CreateSkill } from "./CreateSkill";
import { AddLineManager } from "./AddLineManager";
import { CreateSkillCategory } from "./CreateSkillCategory";
import { CreateRatingObjectives } from "./CreateRatingObjectives";
import { EditNote } from "./EditNote";

const CreateModal = (modalRef, lenis, htmlEditor) => {

  let modalElem = document.getElementById(`${modalRef}`);
  if (modalElem) {

    // modal config
    let modalConfig = {
      placement: "center-center",
      backdrop: "static",
      backdropClasses: "bg-gray-900/50 backdrop-blur fixed inset-0 z-40",
      closable: false,
      onHide: () => {
        //console.log(`${modalRef} hidden`);
        modalElem.querySelector("form").reset();
        if (lenis) {
          lenis.start();
        }
      },
      onShow: () => {
        //console.log(`${modalRef} shown`);
        if (lenis) {
          lenis.stop();
        }
      },
    };

    // init modal
    let modal = new Modal(modalElem, modalConfig, {
      id: `${modalRef}`,
      override: true,
    });
    // let modalInstance = window.FlowbiteInstances.getInstance("Modal", modalRef);

    // function to set state of select indexes
    const setSelectValues = (selectElement, targetValue) => {
      if (selectElement && targetValue !== undefined && targetValue !== null) {
        const options = selectElement.querySelectorAll("option");
        options.forEach((option) => {
          if (option.value === targetValue.toString()) {
            option.selected = true;
          } else {
            option.selected = false; // Optional: Ensure other options are not selected
          }
        });
      }
    };

    // open modal
    let modalTriggers = document.querySelectorAll(
      `[data-modal-target="${modalRef}"]`
    );

    modalTriggers.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();

        let data = btn.dataset;

        // Skill Category
        if (modalRef == "modalAddSkillCategory" && data.modalType == "edit") {
          modalElem.querySelector("input[name=skill_category_type]").value =
            data.modalType;
          modalElem.querySelector("input[name=skill_category_id]").value =
            data.skillCategoryId;
          modalElem.querySelector("input[name=name]").value =
            data.skillCategoryName;
          modalElem.querySelector("textarea[name=description]").value =
            data.skillCategoryDescription;
        }

        // Skill
        if (modalRef == "modalAddSkill" && data.modalType == "edit") {
          modalElem.querySelector("input[name=skill_type]").value =
            data.modalType;
          modalElem.querySelector("input[name=skill_id]").value = data.skillId;
          modalElem.querySelector("input[name=name]").value = data.skillName;
            modalElem.querySelector("input[name=order]").value = data.skillOrder;
          modalElem.querySelector("textarea[name=description]").value =
            data.skillDescription;
          modalElem.querySelector("select[name=category]").value =
            data.skillCategory;
          htmlEditor.setContents(data.skillInformation);
        }

        // Rating Objectives
        if (modalRef == "modalAddRatingObjectives") {
          modalElem.querySelector("input[name=rating_id]").value = data.ratingId;
          htmlEditor.setContents(data.ratingObjectives);
        }

        // User / Line Manager
        if (modalRef == "modalAddLineManager") {
          modalElem.querySelector("input[name=user_id]").value = data.userId;
          modalElem.querySelector("input[name=user_role]").value =
            data.userRole;
          modalElem.querySelector("input[name=user_role_target]").value =
            data.userRoleTarget;
          modalElem.querySelector("input[name=user_first_name]").value =
            data.userFirstName;
          modalElem.querySelector("input[name=user_last_name]").value =
            data.userLastName;
          const selectElementManager = modalElem.querySelector(
            "select[name=user_is_line_manager]"
          );
          setSelectValues(selectElementManager, data.userIsLineManager);
          const selectElement = modalElem.querySelector(
            "select[name=line_manager_id]"
          );
          setSelectValues(selectElement, data.userLineManagerId);
          const selectElement2 = modalElem.querySelector(
            "select[name=department]"
          );
          setSelectValues(selectElement2, data.userDepartment);
        }

        // Note Edit
        if (modalRef == "modalEditNote") {
          modalElem.querySelector("input[name=note_id]").value = data.noteId;
          htmlEditor.setContents(data.noteContent);
        }

        modal.show();

      });
    });

    // close modal button
    let closeButton = document.querySelector(`[data-modal-hide="${modalRef}"]`);
    if (closeButton) {
      closeButton.addEventListener("click", (e) => {
        modal.hide();
        e.preventDefault();
      });
    }

    // submission methods
    switch (modalRef) {
      case "modalAddSkill":
        CreateSkill(modal, htmlEditor);
        break;
      case "modalAddSkillCategory":
        CreateSkillCategory(modal, htmlEditor);
        break;
      case "modalAddLineManager":
        AddLineManager(modal);
        break;
      case "modalAddRatingObjectives":
        CreateRatingObjectives(modal, htmlEditor);
        break;
      case "modalAddNote":
          CreateNote(modal, htmlEditor); 
          break;
      default:
          EditNote(modal, htmlEditor); 
    }

  }
};

export { CreateModal };
